var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-handle"},[_c('CloseButton',{staticClass:"p-2 pr-12",attrs:{"disabled":_vm.navigating,"on-click":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }